import { faSpinner, faTrashCan, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton } from "@mui/material";
import { useState } from "react";

type DeleteStoppageImageButtonProps = {
  fileName: string;
  handleFileDelete: () => Promise<void>;
};

const DeleteStoppageImageButton: React.FC<DeleteStoppageImageButtonProps> = ({
  fileName,
  handleFileDelete
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isWorking, setIsWorking] = useState(false);

  return (
    <IconButton
      sx={{ color: 'white', position: 'relative', width: 40, height: 40 }}
      aria-label={`Delete image ${fileName}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={async () => {
        setIsWorking(true);
        await handleFileDelete();
        setIsWorking(false);
      }}
      classes={{ root: 'hover:shadow-md' }}
    >
      <span
        className="absolute inset-0 flex items-center justify-center transition-opacity ease-in-out"
        style={{ opacity: isWorking ? 1 : 0 }}
      >
        <FontAwesomeIcon icon={faSpinner} spin />
      </span>

      <span
        className="absolute inset-0 flex items-center justify-center transition-opacity ease-in-out"
        style={{ opacity: !isHovered && !isWorking ? 1 : 0 }}
      >
        <FontAwesomeIcon icon={faTrashCan} />
      </span>

      <span
        className="absolute inset-0 flex items-center justify-center transition-opacity ease-in-out"
        style={{ opacity: isHovered && !isWorking ? 1 : 0 }}
      >
        <FontAwesomeIcon icon={faTrash} />
      </span>
    </IconButton>
  );
};

export default DeleteStoppageImageButton;